<template>
  <div id="email-app" class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden mt-2">
    <vs-sidebar class="items-no-padding" parent="#email-app" :click-not-close="clickNotClose" :hidden-background="clickNotClose" v-model="isEmailSidebarActive">
      <email-sidebar @closeSidebar="toggleEmailSidebar" :mailFilter="mailFilter" :isShowReplyPrompt="isShowReplyPrompt" :isShowForwardPrompt="isShowForwardPrompt"
                     @hideReplyPrompt="hideReplyPrompt" @hideForwardPrompt="hideForwardPrompt" :openMailId="openMailId"/>
    </vs-sidebar>
    <div :class="{'sidebar-spacer': clickNotClose}" class="no-scroll-content border border-solid d-theme-border-grey-light border-r-0 border-t-0 border-b-0">
      <vue-element-loading :active="isMailLoading" spinner="bar-fade-scale" color="#e6007e"/>
      <!-- SEARCH BAR -->
      <!--      <div class="flex border d-theme-dark-bg items-center">-->
      <!--        <feather-icon class="md:inline-flex lg:hidden ml-4 mr-4 cursor-pointer" icon="MenuIcon" @click.stop="toggleEmailSidebar(true)"/>-->
      <!--        <vs-input icon-no-border icon="icon-search" size="large" icon-pack="feather" placeholder="Search Mail" v-model="searchQuery"-->
      <!--                  class="vs-input-no-border vs-input-no-shdow-focus w-full"/>-->
      <!--      </div>-->
      <!-- EMAILS LIST -->
      <component :is="scrollbarTag" class="email-content-scroll-area" :settings="settings" ref="mailListPS" :key="$vs.rtl" @ps-scroll-y="emailLazyLoading">
        <transition-group name="list-enter-up" class="email__mails" tag="ul" appear>
          <li class="cursor-pointer email__mail-item" v-for="(mail, index) in mails" :key="String(mailFilter) + String(mail.id)" @click="updateOpenMail(mail.id)"
              :style="{transitionDelay: (index * 0.1) + 's'}">
            <mail-item :mail="mail" :isSelected="isMailSelected(mail.id)" @addToSelected="addToSelectedMails" @removeSelected="removeSelectedMail" :filter="mailFilter"
                       :sent-folder-id="sentFolderId"/>
          </li>
        </transition-group>
      </component>
    </div>

    <!-- EMAIL VIEW SIDEBAR -->
    <email-view :openMailId="openMailId" :isSidebarActive="isSidebarActive" :mailFilter="mailFilter" @showReply="showReplyPrompt" @showForward="showForwardPrompt"
                @markUnread="updateSingleMarkUnread" @removeMail="removeOpenMail" @previousMail="previousMail" @nextMail="nextMail" @moveTo="moveCurrentTo"
                @closeSidebar="closeMailViewSidebar">
    </email-view>
  </div>
</template>

<script>
import EmailSidebar from './EmailSidebar.vue';
import MailItem from './MailItem.vue';
import EmailView from './EmailView.vue';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import moduleEmail from '../../../js/store/modules/email/moduleEmail';
import FeatherIcon from "./components/FeatherIcon";
import VueElementLoading from 'vue-element-loading';

export default {
  name: 'email_inbox',
  data() {
    return {
      openMailId: null,
      selectedMails: [],
      isSidebarActive: false,
      showThread: false,
      clickNotClose: true,
      isEmailSidebarActive: true,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.30
      },
      lazyLoadingGap: 30,
      isShowReplyPrompt: false,
      isShowForwardPrompt: false,
      autoPullEmails: null,
      autoPullTimePeriod: 30
    }
  },
  watch: {
    isSidebarActive(value) {
      if (!value) this.showThread = false
    },
    mailFilter(to, from) {
      if (to === undefined) {
        return;
      }
      const scroll_el = this.$refs.mailListPS.$el || this.$refs.mailListPS;
      scroll_el.scrollTop = 0;
      this.$store.commit('email/SET_MAILS_EMPTY');
      this.$store.commit('email/UPDATE_MAIL_FILTER', this.$route.params.filter);
      this.$store.dispatch('email/fetchEmails', {filter: this.$route.params.filter, maiSkip: this.$store.state.email.mailSkip});
      this.toggleEmailSidebar();
    },
    windowWidth() {
      this.setSidebarWidth();
    }
  },
  computed: {
    mailFilter() {
      return this.$route.params.filter;
    },
    sentFolderId() {
      return this.$store.state.email.sentFolderId;
    },
    searchQuery: {
      get() {
        return this.$store.state.email.mailSearchQuery;
      },
      set(val) {
        this.$store.dispatch('email/setEmailSearchQuery', val);
      }
    },
    selectAllCheckBox: {
      get() {
        return this.selectedMails.length;
      },
      set(value) {
        value ? this.selectedMails = this.mails.map(mail => mail.id) : this.selectedMails = [];
      }
    },
    mails() {
      return this.$store.state.email.mails;
    },
    selectAllIcon() {
      return this.selectedMails.length === this.mails.length ? 'icon-check' : 'icon-minus';
    },
    scrollbarTag() {
      return this.isTouchDevice() ? 'div' : 'VuePerfectScrollbar';
    },
    isMailSelected() {
      return (mailId) => this.selectedMails.indexOf(mailId) !== -1;
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    isMailLoading() {
      return this.$store.state.email.mailLoading;
    }
  },
  methods: {
    emailLazyLoading(evt) {
      if ((evt.target.scrollTop + evt.target.offsetHeight + this.lazyLoadingGap) > evt.target.scrollHeight) {
        if (!this.$store.state.email.mailEnd) {
          if (!this.$store.state.email.mailLoading) {
            this.$store.dispatch('email/fetchEmails', {filter: this.$route.params.filter, maiSkip: this.$store.state.email.mailSkip});
          }
        }
      }
    },
    isTouchDevice() {
      const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
      const mq = function (query) {
        return window.matchMedia(query).matches
      };
      if ('ontouchstart' in window || window.DocumentTouch) {
        return true
      }
      const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
      return mq(query);
    },
    updateOpenMail(mailId) {
      this.openMailId = mailId;
      this.isSidebarActive = true;
    },
    addToSelectedMails(mailId) {
      if (this.selectedMails.indexOf(mailId) === -1) this.selectedMails.push(mailId);
    },
    removeSelectedMail(mailId) {
      const mailIndex = this.selectedMails.indexOf(mailId);
      if (mailIndex !== -1) this.selectedMails.splice(mailIndex, 1);
    },
    moveTo(to) {
      const payload = {emailIds: this.selectedMails, to};
      this.$store.dispatch('email/moveMailsTo', payload).then(() => {
        this.$store.dispatch('email/fetchEmails', {filter: this.$route.params.filter, maiSkip: this.$store.state.email.mailSkip});
      }).catch((error) => {
        console.error(error);
      });
      this.selectedMails = [];
    },
    moveCurrentTo(to) {
      this.selectedMails = [this.openMailId];
      this.moveTo(to)
    },
    updateMarkUnread() {
      const payload = {emailIds: this.selectedMails, unreadFlag: true};
      this.$store.dispatch('email/setUnread', payload).then(() => {
        this.$store.dispatch('email/fetchEmails', {filter: this.$route.params.filter, maiSkip: this.$store.state.email.mailSkip});
        this.$store.dispatch('email/fetchMailFolders');
      });
      this.selectedMails = [];
    },
    removeOpenMail() {
      this.selectedMails = [this.openMailId];
      if (this.$route.params.filter === this.$store.state.email.trashFolderId) {
        this.moveTo("recoverableitemspurges");
      }
      else {
        this.moveTo(this.$store.state.email.trashFolderId);
      }
      this.isSidebarActive = false;
    },
    nextMail() {
      const currentMailIndex = this.mails.findIndex((mail) => mail.id === this.openMailId);
      if (this.mails[currentMailIndex + 1]) this.openMailId = this.mails[currentMailIndex + 1].id;
    },
    previousMail() {
      const currentMailIndex = this.mails.findIndex((mail) => mail.id === this.openMailId);
      if (this.mails[currentMailIndex - 1]) this.openMailId = this.mails[currentMailIndex - 1].id;
    },
    updateSingleMarkUnread() {
      this.selectedMails = [this.openMailId];
      this.updateMarkUnread();
      this.isSidebarActive = false;
    },
    closeMailViewSidebar() {
      this.isSidebarActive = false;
    },
    setSidebarWidth() {
      if (this.windowWidth < 992) {
        this.isEmailSidebarActive = this.clickNotClose = false;
      }
      else {
        this.isEmailSidebarActive = this.clickNotClose = true;
      }
    },
    toggleEmailSidebar(value = false) {
      if (!value) {
        this.closeMailViewSidebar();
        if (this.clickNotClose) {
          return;
        }
      }
      this.isEmailSidebarActive = value;
    },
    showReplyPrompt() {
      this.isShowReplyPrompt = true;
    },
    showForwardPrompt() {
      this.isShowForwardPrompt = true;
    },
    hideReplyPrompt() {
      this.isShowReplyPrompt = false;
    },
    hideForwardPrompt() {
      this.isShowForwardPrompt = false;
    }
  },
  components: {
    MailItem,
    EmailSidebar,
    EmailView,
    VuePerfectScrollbar,
    FeatherIcon,
    VueElementLoading
  },
  created() {
    this.$store.registerModule('email', moduleEmail);
    this.setSidebarWidth();
    this.$store.commit('email/SET_MAILS_EMPTY');
    this.$store.commit('email/SET_MAIL_END', false);
    this.$store.commit('email/SET_MAIL_SKIP', 0);
    this.$store.commit('email/UPDATE_MAIL_FILTER', this.$route.params.filter);// Update Mail Filter
    this.$store.dispatch('email/fetchEmails', {filter: this.$route.params.filter, maiSkip: this.$store.state.email.mailSkip});// Fetch Emails From API

  },
  beforeDestroy() {
    this.$store.unregisterModule('email');
    clearInterval(this.autoPullEmails);
  },
  mounted() {
    this.$store.dispatch('email/setEmailSearchQuery', '');
    this.$store.dispatch('email/fetchMailFolders');//Fetch Mail Folders;
    if (this.autoPullEmails === null) {
      this.autoPullEmails = setInterval(function () {
        this.$store.dispatch('email/fetchMailFolders');
        this.$store.commit('email/SET_MAILS_EMPTY');
        this.$store.dispatch('email/fetchEmails', {filter: this.$route.params.filter, maiSkip: 0});// Fetch Emails From API
      }.bind(this), this.autoPullTimePeriod * 1000);
    }

  }
}

</script>
<style lang="scss" scoped>
.d-theme-border-grey-light {
  border-color: #dae1e7;
}

.border {
  border-width: 1px !important;
}

.border-solid {
  border-style: solid !important;
}

.rounded {
  border-radius: .21875rem !important;
}

.relative {
  position: relative !important;
}

.overflow-hidden {
  overflow: hidden !important;
}
</style>
<style lang="scss">

#email-app {
  transition: none !important;

  .d-theme-border-grey-light {
    border-color: #dae1e7;
  }

  .border {
    border-width: 1px !important;
  }

  .border-solid {
    border-style: solid !important;
  }

  .rounded {
    border-radius: .22rem !important;
  }

  .relative {
    position: relative !important;
  }

  .overflow-hidden {
    overflow: hidden !important;
  }

  .vs-sidebar.vs-sidebar-parent {
    position: absolute;
    height:   100% !important;
    top:      0;
  }

  .vuesax-app-is-ltr .vs-sidebar {
    left: 0;
  }

  .vs-sidebar {
    height: calc(var(--vh, 1vh) * 100);
  }

  .vs-sidebar {
    background:         #fff;
    position:           fixed;
    height:             100vh;
    width:              100%;
    max-width:          260px;
    top:                0;
    display:            -ms-flexbox;
    display:            flex;
    -ms-flex-direction: column;
    flex-direction:     column;
    box-shadow:         0 0 15px 0 rgba(0, 0, 0, .05);
    z-index:            40;
  }

  .vs-content-sidebar.items-no-padding .vs-sidebar--items {
    padding: 0;
  }

  .vs-sidebar .vs-sidebar--items {
    overflow: hidden;
    height:   100%;
  }

  .vs-sidebar--items {
    padding:    10px 0;
    background: inherit;
    overflow-y: auto;
  }

  .h-full {
    height: 100% !important;
  }

  .m-6 {
    margin: 1.31rem !important;
  }

  .clearfix:after {
    content: "" !important;
    display: table !important;
  }

  .vs-button:not(.vs-radius):not(.includeIconOnly):not(.small):not(.large) {
    padding: 0.66rem 1.75rem;
  }

  .vs-button.includeIcon {
    float: none;
  }

  .bg-primary-gradient {
    background: linear-gradient(118deg, rgba(var(--vs-primary), 1), rgba(var(--vs-primary), 0.7)) !important;
  }

  .vs-button-primary.vs-button-filled {
    background: rgba(var(--vs-primary), 1) !important;
  }

  .vuesax-app-is-ltr .includeIcon {
    float: left;
  }

  .vs-button {
    font-family: "Montserrat", Helvetica, Arial, sans-serif;
    font-size:   0.875rem;
  }

  .includeIcon {
    display:         -ms-flexbox;
    display:         flex;
    -ms-flex-align:  center;
    align-items:     center;
    -ms-flex-pack:   center;
    justify-content: center;
  }

  .vs-button {
    transition:    all .2s ease;
    padding:       10px;
    border:        0;
    border-radius: 6px;
    cursor:        pointer;
    position:      relative;
    overflow:      hidden;
    color:         #fff;
    box-sizing:    border-box;
    background:    transparent;
  }

  .vs-button--background {
    border-radius:  50%;
    width:          10px;
    position:       absolute;
    height:         10px;
    z-index:        0;
    transform:      translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    box-shadow:     inset 0 0 60px 0 hsla(0, 0%, 100%, .5);
  }

  i.feather {
    font-weight: 100;
  }

  .vs-button--icon {
    z-index:    100;
    display:    block;
    position:   relative;
    font-size:  0.98rem;
    transition: all .2s ease;
  }

  .vs-icon {
    color:      inherit;
    text-align: center;
    font-size:  0.875rem;
  }

  .vs-button--text {
    position:    relative;
    color:       inherit;
    display:     inline-block;
    transition:  all .25s ease;
    line-height: normal;
  }

  .w-full {
    width: 100% !important;
  }

  .ps-container {
    position: relative;
  }

  .ps {
    -ms-touch-action:   auto;
    touch-action:       auto;
    overflow:           hidden !important;
    -ms-overflow-style: none;
  }

  .email-filter-scroll-area {
    margin: auto;
  }

  .email-filter-scroll-area {
    position: relative;
    width:    100%;
    height:   calc(100% - 75px);
  }

  .pb-2 {
    padding-bottom: 0.44rem !important;
  }

  .px-6 {
    padding-left:  1.31rem !important;
    padding-right: 1.31rem !important;
  }

  .flex-col {
    flex-direction: column !important;
  }

  .flex {
    display: flex !important;
  }

  .cursor-pointer {
    cursor: pointer !important;
  }

  .text-primary {
    color: rgba(var(--vs-primary), 1) !important;
  }

  .justify-between {
    justify-content: space-between !important;
  }

  .items-center {
    align-items: center !important;
  }

  .mb-2 {
    margin-bottom: 0.44rem !important;
  }

  .feather-icon {
    display:     inline-flex;
    align-items: center;
  }

  .select-none {
    -webkit-user-select: none !important;
    -moz-user-select:    none !important;
    -ms-user-select:     none !important;
    user-select:         none !important;
  }

  .ml-3 {
    margin-left: 0.66rem !important;
  }

  .text-lg {
    //font-size: 0.99rem !important;
  }

  .con-vs-chip.number {
    padding-right: unset;
    margin-right:  0;
  }

  .con-vs-chip.number {
    min-height: 20px;
    min-width:  20px;
  }

  .vs-chip-primary:not(.bg-chip-transparent) {
    background: rgba(var(--vs-primary), 1);
  }

  .vuesax-app-is-ltr .con-vs-chip {
    padding-right: 10px;
  }

  .vuesax-app-is-ltr .con-vs-chip {
    margin-right: 2px;
  }

  .vuesax-app-is-ltr .con-vs-chip {
    float: left;
  }

  .con-vs-chip {
    min-height: 26px;
    min-width:  26px;
    font-size:  0.7rem;
  }

  .con-vs-chip {
    background:      #f0f0f0;
    border-radius:   20px;
    display:         -ms-flexbox;
    display:         flex;
    -ms-flex-align:  center;
    align-items:     center;
    font-size:       .62rem;
    -ms-flex-pack:   center;
    justify-content: center;
    margin-bottom:   3px;
    min-height:      28px;
    color:           rgba(0, 0, 0, .7);
    position:        relative;
  }

  .con-vs-chip .number .vs-chip--text {
    margin-left:  unset;
    margin-right: unset;
  }

  .con-vs-chip.number .vs-chip--text {
    font-weight: 600;
  }

  .vuesax-app-is-ltr .vs-chip--text {
    margin-left: 10px;
  }

  .vs-chip--text {
    display:         -ms-flexbox;
    display:         flex;
    -ms-flex-align:  center;
    align-items:     center;
    -ms-flex-pack:   center;
    justify-content: center;
  }

  //.mt-4 {
  //  margin-top: 0.88rem !important;
  //}

  .vs-chip-warning:not(.bg-chip-transparent) {
    background: rgba(var(--vs-warning), 1);
  }

  .vs-chip-danger:not(.bg-chip-transparent) {
    background: rgba(var(--vs-danger), 1);
  }

  .vs-divider {
    width:           100%;
    position:        relative;
    display:         block;
    margin:          15px 0;
    clear:           both;
    display:         -ms-flexbox;
    display:         flex;
    -ms-flex-align:  center;
    align-items:     center;
    -ms-flex-pack:   center;
    justify-content: center;
  }

  .vs-divider .after, .vs-divider .before {
    position: relative;
    display:  block;
    width:    100%;
  }

  .py-4 {
    padding-top:    0.88rem !important;
    padding-bottom: 0.88rem !important;
  }

  .mb-8 {
    margin-bottom: 1.76rem !important;
  }

  h5, .h5 {
    font-size: 15.96px;
  }

  h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {
    font-family: inherit;
    font-weight: 500;
    line-height: 1.2;
    color:       #2c2c2c;
  }

  .mb-4 {
    margin-bottom: 0.88rem !important;
  }

  .border-success {
    border-color: rgba(var(--vs-success), 1) !important;
  }

  .mr-4 {
    margin-right: 0.88rem !important;
  }

  .ml-1 {
    margin-left: 0.22rem !important;
  }

  .border-2 {
    border-width: 2px !important;
  }

  .border-solid {
    border-style: solid !important;
  }

  .rounded-full {
    border-radius: 9999px !important;
  }

  .w-3 {
    width: 0.66rem !important;
  }

  .h-3 {
    height: 0.66rem !important;
  }

  .no-scroll.navbar-floating .no-scroll-content {
    height: calc(var(--vh, 1vh) * 100 - 10.1rem);
  }

  .sidebar-spacer {
    margin-left: 260px;
  }

  .border-b-0 {
    border-bottom-width: 0 !important;
  }

  .border-r-0 {
    border-right-width: 0 !important;
  }

  .border-t-0 {
    border-top-width: 0 !important;
  }

  .sidebar-spacer {
    width: calc(100% - 260px);
  }

  .no-scroll-content {
    //height: calc(var(--vh, 1vh) * 100 - 12.4rem);
    height: calc(var(--vh, 1vh) * 100);
  }

  .d-theme-dark-bg, .d-theme-dark-light-bg {
    background-color: #fff;
  }

  .ml-4 {
    margin-left: 0.88rem !important;
  }

  .feather.feather-menu {
    z-index: 9;
  }

  .vs-con-input-label {
    position:   relative;
    transition: all .3s ease;
    width:      200px;
  }

  .vs-con-input-label .vs-con-input {
    display:            -ms-flexbox;
    display:            flex;
    -ms-flex-align:     start;
    align-items:        flex-start;
    -ms-flex-direction: column;
    flex-direction:     column;
    position:           relative;
    -ms-flex-pack:      center;
    justify-content:    center;
  }

  .vs-input--input.large.hasIcon {
    padding:       0.88rem 0.7rem 0.88rem 2.64rem !important;
    outline-width: 0;
  }

  .vs-input--input.hasIcon {
    padding: 0.6rem 0.88rem 0.6rem 2.64rem !important;
  }

  .vs-input--input.large {
    padding: 0.88rem !important;
  }

  .vs-con-input .vs-inputx {
    padding: 0.6rem;
    border:  1px solid rgba(0, 0, 0, 0.2);
  }

  .vs-input-no-border .vs-input--input {
    border: none !important;
  }

  .vuesax-app-is-ltr .vs-input--input.hasIcon {
    padding-left: 32px;
  }

  .vs-input--input.large {
    font-size: 1rem !important;
  }

  .vs-con-input .vs-inputx {
    font-size: 0.88rem;
  }

  .vs-input--input.large {
    padding: .7rem;
  }

  .vs-input--input {
    color:         inherit;
    position:      relative;
    padding:       .35rem;
    border-radius: 5px;
    border:        1px solid rgba(0, 0, 0, .2);
    box-sizing:    border-box;
    box-shadow:    0 0 0 0 rgba(0, 0, 0, .15);
    transition:    all .3s ease;
    width:         100%;
  }

  .vs-input--input.hasIcon:not(.icon-after-input) + .vs-input--placeholder {
    padding-left: 2.6rem !important;
  }

  .vuesax-app-is-ltr .vs-input--input.hasIcon + .vs-input--placeholder {
    padding-left: 32px;
  }

  .vs-input--placeholder.large {
    padding: 0.88rem !important;
  }

  .vs-input--placeholder.large {
    padding:     .61rem;
    padding-top: 1.1rem !important;
  }

  .vuesax-app-is-ltr .vs-input--placeholder {
    padding-left: .44rem;
  }

  .vs-input--placeholder {
    transition:          all .2s ease;
    position:            absolute;
    border-radius:       5px;
    padding:             .35rem;
    width:               100%;
    box-sizing:          border-box;
    overflow:            hidden;
    font-size:           .74rem;
    color:               rgba(0, 0, 0, .4);
    white-space:         nowrap;
    cursor:              text;
    -webkit-user-select: none;
    -ms-user-select:     none;
    user-select:         none;
    top:                 -1px;
    pointer-events:      none;
  }

  .vuesax-app-is-ltr .vs-input--placeholder {
    left: 0;
  }

  .vs-input--placeholder {
    top: 0;
  }

  .vs-input--icon {
    position:            absolute;
    z-index:             1;
    font-size:           0.96rem;
    color:               rgba(0, 0, 0, .4);
    cursor:              default;
    -webkit-user-select: none;
    -ms-user-select:     none;
    user-select:         none;
    top:                 8px;
  }

  .vs-input--input.large ~ .vs-input--icon {
    left: 0.7rem !important;
  }

  .vs-input--icon.feather {
    padding: 0.17rem 0.44rem 0 0.35rem;
  }

  .vs-input--input.large ~ .vs-input--icon {
    top: 0.88rem !important;
  }

  .vs-input--icon.icon-no-border {
    border: 0;
  }

  .vuesax-app-is-ltr .vs-input--icon {
    padding-right: 3px;
  }

  .vuesax-app-is-ltr .vs-input--icon {
    border-right: 1px solid rgba(0, 0, 0, .1);
  }

  .vuesax-app-is-ltr .vs-input--icon {
    left: 5px;
  }

  i.feather {
    font-weight: 100;
  }

  @media (min-width: 768px) {
    .md\:inline-flex {
      display: inline-flex !important;
    }
  }
  @media (min-width: 992px) {
    .lg\:hidden {
      display: none !important;
    }
  }

  .p-4 {
    padding: 0.88rem !important;
  }

  .border-l-0 {
    border-left-width: 0 !important;
  }

  .flex-wrap {
    flex-wrap: wrap !important;
  }

  .ml-0 {
    margin-left: 0 !important;
  }

  .con-vs-checkbox {
    position:        relative;
    display:         block;
    display:         -ms-flexbox;
    display:         flex;
    -ms-flex-align:  center;
    align-items:     center;
    -ms-flex-pack:   center;
    justify-content: center;
    margin-left:     5px;
    margin-right:    5px
  }

  .con-vs-checkbox.vs-checkbox-small .vs-checkbox {
    width:  15px;
    height: 15px
  }

  .con-vs-checkbox.vs-checkbox-small .vs-checkbox .vs-icon {
    font-size: .61rem
  }

  .con-vs-checkbox.vs-checkbox-large .vs-checkbox {
    width:  24px;
    height: 24px
  }

  .vs-checkbox--input {
    position:   absolute;
    width:      100%;
    height:     100%;
    opacity:    0;
    z-index:    200;
    cursor:     pointer;
    background: #55d775
  }

  .vs-checkbox--input:disabled {
    cursor:         default;
    pointer-events: none
  }

  .vs-checkbox--input:disabled + .vs-checkbox {
    opacity:        .5;
    cursor:         default;
    pointer-events: none
  }

  .vs-checkbox--input:disabled + .vs-checkbox .vs-checkbox--check {
    cursor:         default;
    pointer-events: none
  }

  .vs-checkbox--input:active:checked + .vs-checkbox .vs-checkbox--check {
    transform: translate(3px)
  }

  .vs-checkbox--input:active:checked + .vs-checkbox .vs-icon {
    transform: translate(6px)
  }

  .vs-checkbox--input:checked + .vs-checkbox {
    transform: rotate(0deg)
  }

  .vs-checkbox--input:checked + .vs-checkbox .vs-checkbox--check {
    transform: translate(0)
  }

  .vs-checkbox--input:checked + .vs-checkbox .vs-icon {
    opacity:   1;
    transform: translate(0);
    color:     #fff;
    display:   -ms-flexbox;
    display:   flex
  }

  .vs-checkbox, .vs-checkbox--input:checked + .vs-checkbox .vs-icon {
    -ms-flex-align:  center;
    align-items:     center;
    -ms-flex-pack:   center;
    justify-content: center
  }

  .vs-checkbox {
    transition:    all .2s ease;
    cursor:        pointer;
    position:      relative;
    display:       block;
    width:         20px;
    height:        20px;
    border-radius: 2px;
    display:       -ms-flexbox;
    display:       flex;
    transform:     rotate(-90deg);
    overflow:      hidden;
    box-sizing:    border-box
  }

  .vuesax-app-is-rtl .vs-checkbox {
    margin-left: 5px
  }

  .vuesax-app-is-ltr .vs-checkbox {
    margin-right: 5px
  }

  .vs-checkbox--check {
    width:            100%;
    height:           100%;
    position:         absolute;
    left:             0;
    transform:        translate(100%);
    transform-origin: right;
    transition:       all .2s ease;
    z-index:          10
  }

  .vs-checkbox--check {
    display:         flex;
    align-items:     center;
    justify-content: center;
  }

  .vs-checkbox--icon {
    -webkit-backface-visibility: visible;
    backface-visibility:         visible;
    transition:                  all .2s ease-out;
    z-index:                     100;
    font-size:                   1.125em;
    opacity:                     0;
    transform:                   translate(30px);
    transform-origin:            center
  }

  .vs-checkbox-primary .vs-checkbox {
    border: 2px solid #b4b4b4
  }

  .vs-checkbox-primary input:checked + .vs-checkbox {
    border:     2px solid rgba(var(--vs-primary), 1) !important;
    background: rgba(var(--vs-primary), 1)
  }

  .vs-checkbox-secondary .vs-checkbox {
    border: 2px solid #b4b4b4
  }

  .vs-checkbox-secondary input:checked + .vs-checkbox {
    border:     2px solid rgba(var(--vs-secondary), 1) !important;
    background: rgba(var(--vs-secondary), 1)
  }

  .vs-checkbox-danger .vs-checkbox {
    border: 2px solid #b4b4b4
  }

  .vs-checkbox-danger input:checked + .vs-checkbox {
    border:     2px solid rgba(var(--vs-danger), 1) !important;
    background: rgba(var(--vs-danger), 1)
  }

  .vs-checkbox-success .vs-checkbox {
    border: 2px solid #b4b4b4
  }

  .vs-checkbox-success input:checked + .vs-checkbox {
    border:     2px solid rgba(var(--vs-success), 1) !important;
    background: rgba(var(--vs-success), 1)
  }

  .vs-checkbox-warning .vs-checkbox {
    border: 2px solid #b4b4b4
  }

  .vs-checkbox-warning input:checked + .vs-checkbox {
    border:     2px solid rgba(var(--vs-warning), 1) !important;
    background: rgba(var(--vs-warning), 1)
  }

  .vs-checkbox-dark .vs-checkbox {
    border: 2px solid #b4b4b4
  }

  .vs-checkbox-dark input:checked + .vs-checkbox {
    border:     2px solid rgba(var(--vs-dark), 1) !important;
    background: rgba(var(--vs-dark), 1)
  }

  .vs-checkbox-light .vs-checkbox {
    border: 2px solid #b4b4b4
  }

  .vs-checkbox-light input:checked + .vs-checkbox {
    border:     2px solid rgba(var(--vs-light), 1) !important;
    background: rgba(var(--vs-light), 1)
  }

  .select-all-chexkbox .vs-checkbox {
    margin-right: 0.8rem;
  }

  .ml-5 {
    margin-left: 1.1rem !important;
  }

  .vs-con-dropdown {
    color:     inherit;
    font-size: 0.88rem;
  }

  .w-6 {
    width: 1.32rem !important;
  }

  .h-6 {
    height: 1.32rem !important;
  }

  button {
    line-height: normal;
  }

  .email-content-scroll-area {
    position: relative;
    width:    100%;
    height:   calc(100% - 80px);
  }

  .email-content-scroll-area {
    margin: auto;
  }

  ul, ol {
    list-style-type: none;
    margin:          0;
    padding:         0;
  }

  .email__mails .email__mail-item {
    transition:    all 0.35s;
    border-bottom: 1px solid rgb(222, 226, 230);
  }

  .px-2 {
    padding-left:  0.44rem !important;
    padding-right: 0.44rem !important;
  }

  .py-6 {
    padding-top:    1.32rem !important;
    padding-bottom: 1.32rem !important;
  }

  @media (min-width: 576px) {
    .sm\:px-4 {
      padding-left:  0.88rem !important;
      padding-right: 0.88rem !important;
    }
  }

  .email__mails .email__mail-item .mail__mail-item {

  }

  .mail__message, .mail__content {
    font-family: Calibri, serif;
    color:       #404040;
  }

  .border-white {
    --border-opacity: 1 !important;
  }

  .flex-shrink-0 {
    flex-shrink: 0 !important;
  }

  .con-vs-avatar {
    width:         32px;
    height:        32px;
    border-radius: 50%;
    position:      relative;
    cursor:        pointer;
    display:       inline-block;
    margin:        5px;
  }

  .vs-avatar--con-img {
    position:      absolute;
    width:         100%;
    height:        100%;
    overflow:      hidden;
    border-radius: 50%;
  }

  .vs-avatar--con-img img {
    width:  100%;
    height: 100%;
  }

  .items-start {
    align-items: flex-start !important;
  }

  .mb-1 {
    margin-bottom: 0.22rem !important;
  }

  .hidden {
    display: none !important;
  }

  @media (min-width: 576px) {
    .sm\:flex {
      display: flex !important;
    }
  }

  .w-2 {
    width: 0.44rem !important;
  }

  .h-2 {
    height: 0.44rem !important;
  }

  .bg-primary {
    background-color: rgba(var(--vs-primary), 1) !important;
  }

  .bg-success {
    background-color: rgba(var(--vs-success), 1) !important;
  }

  .bg-danger {
    background-color: rgba(var(--vs-danger), 1) !important;
  }

  .bg-dark {
    background-color: rgba(var(--vs-dark), 1) !important;
  }

  .mr-1 {
    margin-right: 0.22rem !important;
  }

  .vs-checkbox-small .vs-checkbox--input:checked + .vs-checkbox .vs-icon {
    margin-top: 6px;
    transform:  translateY(-3px);
  }

  .vs-checkbox-small .vs-checkbox--input:checked + .vs-checkbox .vs-icon {
    margin-left: -1px;
  }

  .email__mails .email__mail-item .mail__mail-item .feather-icon {
    color: #9c9c9c;
  }

  .h-5 {
    height: 1.1rem !important;
  }

  .fill-current {
    fill: currentColor !important;
  }

  .stroke-current {
    stroke: currentColor !important;
  }

  .w-5 {
    width: 1.1rem !important;
  }

  .text-warning {
    color: rgba(var(--vs-warning), 1) !important;
  }

  .text-danger {
    color: rgba(var(--vs-danger), 1) !important;
  }

  .text-success {
    color: rgba(var(--vs-success), 1) !important;
  }

  .text-primary {
    color: rgba(var(--vs-primary), 1) !important;
  }

  .text-dark {
    color: rgba(var(--vs-dark), 1) !important;
  }

  .truncate {
    overflow:      hidden !important;
    text-overflow: ellipsis !important;
    white-space:   nowrap !important;
  }

  .vs-sidebar.vs-sidebar-parent {
    position: absolute;
    height:   100% !important;
    top:      0;
  }

  .full-vs-sidebar .vs-sidebar {
    max-width: calc(100% - 260px);
  }

  .vuesax-app-is-ltr .vs-sidebar.vs-sidebar-position-right {
    left: auto;
  }

  .vuesax-app-is-ltr .vs-sidebar.vs-sidebar-position-right {
    right: 0;
  }

  .full-vs-sidebar .vs-sidebar {
    margin-left: 260px;
  }

  .email-view-sidebar .vs-sidebar {
    background-color: #f8f8f8 !important;
  }

  .email-view-sidebar .vs-sidebar {
    border-left: 1px solid #dae1e7;
  }

  .px-0 {
    padding-left:  0 !important;
    padding-right: 0 !important;
  }

  @media (min-width: 576px) {
    .sm\:pb-6 {
      padding-bottom: 1.32rem !important;
    }
  }

  .pt-6 {
    padding-top: 1.32rem !important;
  }

  @media (min-width: 576px) {
    .sm\:pb-2 {
      padding-bottom: 0.5rem !important;
    }
  }
  @media (min-width: 768px) {
    .md\:px-8 {
      padding-left:  2rem !important;
      padding-right: 2rem !important;
    }
  }

  h4, .h4 {
    font-size: 18.48px;
  }

  .mt-1 {
    margin-top: 0.22rem !important;
  }

  .ml-10 {
    margin-left: 2.2rem !important;
  }

  .items-baseline {
    align-items: baseline !important;
  }

  @media (min-width: 576px) {
    .sm\:inline-flex {
      display: inline-flex !important;
    }
  }

  .pt-4 {
    padding-top: 0.88rem !important;
  }

  .pb-6 {
    padding-bottom: 1.32rem !important;
  }

  @media (min-width: 768px) {
    .md\:pb-8 {
      padding-bottom: 1.76rem !important;
    }
  }

  .scroll-area-mail-content {
    position: relative;
    width:    100%;
    height:   calc(100% - 6.3%);
  }

  .vx-row {
    display:   flex;
    flex-wrap: wrap;
  }

  .vx-row {
    margin: 0 -0.88rem;
  }

  .vx-row > .vx-col {
    padding: 0 0.88rem;
  }

  .mt-2 {
    margin-top: 0.44rem !important;
  }

  .email-view-sidebar .open-mail-label {
    transition: all 0.35s;
  }

  .text-sm {
    font-size: .77rem !important;
  }

  .vx-card {
    width:    100%;
    display:  block;
    position: relative;
  }

  .px-4 {
    padding-left:  0.88rem !important;
    padding-right: 0.88rem !important;
  }

  .vs-con-loading__container {
    position: relative;
    overflow: hidden;
  }

  .vx-card .vx-card__collapsible-content {

  }

  .vx-card .vx-card__collapsible-content.vs-con-loading__container {
    overflow: unset;
  }

  .vx-card .vx-card__collapsible-content .vx-card__body {
    padding: 1.32rem;
  }

  .border-b {
    border-bottom-width: 1px !important;
  }

  .vx-card .vx-card__collapsible-content img {
    display: block;
  }

  .p-2 {
    padding: 0.44rem !important;
  }

  .justify-end {
    justify-content: flex-end !important;
  }

  .text-right {
    text-align: right !important;
  }

  .break-words {
    word-wrap:     break-word !important;
    overflow-wrap: break-word !important;
  }

  .mt-8 {
    margin-top: 1.76rem !important;
  }

  .mb-6 {
    margin-bottom: 1.32rem !important;
  }

  .block {
    display: block !important;
  }

  .py-2 {
    padding-top:    0.44rem !important;
    padding-bottom: 0.44rem !important;
  }

  .email-view-sidebar .mail__attachment .vs-chip--text {
    margin-left:  0;
    margin-right: 0;
  }
}

#email-app {
  margin:          0;
  padding:         0;
  box-sizing:      border-box;
  outline:         none;
  text-transform:  none;
  text-decoration: none;
  height:          calc(100vh - 120px);
  color:           #626262;
  font-size:       12px;
  line-height:     1.5;
  letter-spacing:  0.0875rem;
  font-family:     "Montserrat", Helvetica, Arial, sans-serif;
  font-weight:     400;
  overflow-x:      hidden;
  max-width:       100%;
}

#email-app * {
  --vs-primary:    115, 103, 240;
  --vs-success:    40, 199, 111;
  --vs-danger:     234, 84, 85;
  --vs-warning:    255, 159, 67;
  --vs-dark:       30, 30, 30;
  --vh:            9.69px;
  margin:          0;
  padding:         0;
  box-sizing:      border-box;
  outline:         none;
  text-transform:  none;
  text-decoration: none;
  transition:      none !important;
}

.rounded-full {
  border-radius: 9999px !important;
}

.w-3 {
  width: 0.66rem !important;
}

.h-3 {
  height: 0.66rem !important;
}

.font-semibold {
  font-weight: 600 !important;
}

.mr-2 {
  margin-right: 0.44rem !important;
}

.w-4 {
  width: 0.88rem !important;
}

.h-4 {
  height: 0.88rem !important;
}

.dropdown-group-enter-active, .dropdown-group-leave-active {
  transition: opacity .25s
}

.dropdown-group-enter, .dropdown-group-leave-to {
  opacity: 0
}

.vs-con-dropdown {
  position:   relative;
  display:    inline-block;
  border:     0;
  background: transparent
}

.vs-con-dropdown * {
  pointer-events: none
}

.vs-con-dropdown a {
  -webkit-user-select: none !important;
  -ms-user-select:     none !important;
  user-select:         none !important
}

.vs-con-dropdown:active {
  opacity: 1 !important
}

.vuesax-app-is-rtl .vs-con-dropdown .a-icon {
  -ms-flex-direction: row-reverse;
  flex-direction:     row-reverse
}

.vs-dropdown--group {
  position:      relative;
  list-style:    none;
  //width:         calc(100% - 6px);
  margin-left:   3px;
  width:         auto;
  display:       block;
  padding:       5px 10px;
  box-sizing:    border-box;
  cursor:        pointer;
  transition:    all .3s ease
}

.vs-dropdown--group.marginIcon {
  padding-right: 25px
}

.vs-dropdown--group.marginIcon:hover .con-dropdown--group {
  border-left: 1px solid rgba(0, 0, 0, .1)
}

.vs-dropdown--group.marginIcon:hover > .icon-group {
  transform: translateY(-50%) rotate(-180deg);
  opacity:   0
}

.vs-dropdown--group-label {
  font-size:      .9375em;
  font-weight:    400;
  pointer-events: none
}

.vs-dropdown--group-icon {
  position:   absolute;
  right:      4px;
  font-size:  1.125em;
  top:        50%;
  transition: all .25s ease;
  transform:  translateY(-50%)
}

.con-dropdown--group-con-ul {
  padding-left: 3px;
  position:     relative;
  right:        0;
  top:          0;
  min-width:    130px;
  width:        auto;
  z-index:      1000;
  background:   inherit;
  overflow:     hidden;
  transition:   all .3s ease;
  border-left:  1px solid rgba(0, 0, 0, .1)
}

.con-dropdown--group-ul {
  padding-top:   5px;
  padding-left:  0;
  position:      relative;
  background:    #fff;
  border-radius: 5px
}

.no-cascading {
  font-weight:   700;
  border-top:    1px solid rgba(0, 0, 0, .05);
  padding-left:  0 !important;
  padding-right: 0 !important;
  margin-top:    5px !important;
  margin-left:   0
}

.no-cascading > h3 {
  font-size:      .9375em;
  padding:        6px 10px;
  cursor:         default
}

.no-cascading .con-dropdown--group-no-cascading {
  width:       100% !important;
  font-weight: 700;
  height:      auto !important;
  opacity:     1 !important;
  border-left: 1px solid transparent !important
}

.no-cascading .con-dropdown--group-no-cascading ul {
  width:        100%;
  box-shadow:   0 5px 20px 0 transparent !important;
  padding-left: 0 !important
}

.vs-dropdown--item {
  transition:    all .2s ease;
  position:      relative;
  z-index:       100;
  border-radius: 5px;
  width:         calc(100% - 6px);
  margin:        0 3px;
  list-style:    none;
  font-weight:   400 !important;
  font-size:     .9375em
}

.vuesax-app-is-rtl .vs-dropdown--item {
  text-align: right
}

.vuesax-app-is-ltr .vs-dropdown--item {
  text-align: left;
  min-width:  100px;
}

.vs-dropdown--item .vs-dropdown--item-link {
  background:      inherit !important;
  color:           inherit !important;
  cursor:          pointer;
  transition:      all .2s ease;
  padding:         5px 10px;
  width:           100%;
  position:        relative;
  display:         block;
  //color:           rgba(0, 0, 0, .7);
  text-decoration: none;
  font-weight:     400 !important;
  font-size:       .9375em;
  font-family:     "Montserrat", Helvetica, Arial, sans-serif;

}

.vs-dropdown--item .vs-dropdown--item-link.disabled {
  -webkit-user-select: none;
  -ms-user-select:     none;
  user-select:         none;
  pointer-events:      none !important;
  cursor:              default;
  opacity:             .5 !important;
  color:               rgba(0, 0, 0, .5) !important
}

.vs-dropdown--item.divider {
  border-top: 1px solid rgba(0, 0, 0, .08);
  margin-top: 5px
}

.dropdownx-enter, .dropdownx-leave-to {
  opacity:   0;
  transform: translate(-100%, 8px) !important
}

.con-vs-dropdown--menu {
  padding-top: 10px;
  position:    absolute;
  height:      auto;
  width:       auto;
  z-index:     40000;
  transform:   translate(-100%);
  transition:  opacity .25s, transform .25s, width .3s ease
}

.con-vs-dropdown--menu.rightx .vs-dropdown--menu--after {
  left:  30px;
  right: 0
}

.con-vs-dropdown--menu:after {
  content:  "";
  display:  block;
  width:    100%;
  height:   10px;
  position: absolute;
  left:     0;
  top:      100%
}

.vs-dropdown--menu {
  background:     #fff;
  padding-left:   0 !important;
  border-radius:  5px;
  box-shadow:     0 5px 25px 0 rgba(0, 0, 0, .1);
  border:         1px solid rgba(0, 0, 0, .1);
  padding-top:    5px;
  padding-bottom: 5px;
  position:       relative;
  margin:         0
}

.vs-dropdown-right--menu--after {
  left: 20px
}

.vs-dropdown--menu--after, .vs-dropdown-right--menu--after {
  position:    absolute;
  width:       10px;
  height:      10px;
  display:     block;
  background:  #fff;
  transform:   rotate(45deg) translate(-7px);
  border-top:  1px solid rgba(0, 0, 0, .1);
  border-left: 1px solid rgba(0, 0, 0, .1);
  z-index:     10;
  box-sizing:  border-box
}

.vs-dropdown--menu--after {
  right: 10px
}

.notHeight .vs-dropdown-menu:after {
  top:           auto;
  bottom:        0;
  border-top:    1px solid transparent;
  border-left:   1px solid transparent;
  border-bottom: 1px solid rgba(0, 0, 0, .1);
  border-right:  1px solid rgba(0, 0, 0, .1);
  transform:     rotate(45deg) translate(7px)
}

.inline-block {
  display: inline-block !important;
}

.mr-3 {
  margin-right: 0.66rem !important;
}

.vs-dropdown--custom {
  padding:     5px !important;
  padding-top: 8px !important
}

.dialog-t-enter, .dialog-t-leave-to {
  opacity: 0 !important
}

.dialog-t-enter .vs-dialog, .dialog-t-leave-to .vs-dialog {
  transform: scale(.9) !important
}

.dialog-t-enter .vs-dialog-cancel, .dialog-t-leave-to .vs-dialog-cancel {
  border-radius: 50% !important
}

.vuesax-app-is-rtl .dialog-t-enter .vs-dialog-cancel, .vuesax-app-is-rtl .dialog-t-leave-to .vs-dialog-cancel {
  transform: translate(-8px, -8px) scale(.5) !important
}

.vuesax-app-is-ltr .dialog-t-enter .vs-dialog-cancel, .vuesax-app-is-ltr .dialog-t-leave-to .vs-dialog-cancel {
  transform: translate(8px, -8px) scale(.5) !important
}

.dialog-t-enter .vs-dialog-text, .dialog-t-leave-to .vs-dialog-text {
  opacity: 0
}

.vuesax-app-is-rtl .dialog-t-enter .vs-dialog-text, .vuesax-app-is-rtl .dialog-t-leave-to .vs-dialog-text {
  transform: translate(15px) !important
}

.vuesax-app-is-ltr .dialog-t-enter .vs-dialog-text, .vuesax-app-is-ltr .dialog-t-leave-to .vs-dialog-text {
  transform: translate(-15px) !important
}

.dialog-t-enter .after, .dialog-t-leave-to .after {
  height: 0 !important
}

.dialog-t-enter header h3, .dialog-t-leave-to header h3 {
  opacity: 0
}

.vuesax-app-is-rtl .dialog-t-enter header h3, .vuesax-app-is-rtl .dialog-t-leave-to header h3 {
  transform: translate(50px) !important
}

.vuesax-app-is-ltr .dialog-t-enter header h3, .vuesax-app-is-ltr .dialog-t-leave-to header h3 {
  transform: translate(-50px) !important
}

.dialog-t-enter footer button, .dialog-t-leave-to footer button {
  transform: translateY(10px);
  opacity:   0
}

.con-vs-dialog {
  transition:      all .2s;
  width:           100%;
  height:          100%;
  position:        fixed;
  top:             0;
  z-index:         30000;
  display:         -ms-flexbox;
  display:         flex;
  -ms-flex-align:  center;
  align-items:     center;
  -ms-flex-pack:   center;
  justify-content: center;
  opacity:         1
}

.vuesax-app-is-rtl .con-vs-dialog {
  right: 0
}

.vuesax-app-is-ltr .con-vs-dialog {
  left: 0
}

.con-vs-dialog .vs-dialog-dark {
  width:      100%;
  background: rgba(0, 0, 0, .4);
  position:   absolute;
  top:        0;
  height:     100%;
  z-index:    10;
  transition: all .25s ease;
  opacity:    1
}

.vuesax-app-is-rtl .con-vs-dialog .vs-dialog-dark {
  right: 0
}

.vuesax-app-is-ltr .con-vs-dialog .vs-dialog-dark {
  left: 0
}

.con-vs-dialog .vs-dialog {
  transition:    all .2s;
  z-index:       100;
  width:         calc(100% - 20px);
  margin:        10px;
  max-width:     400px;
  border-radius: 6px;
  box-shadow:    0 5px 20px 0 rgba(0, 0, 0, .1);
  background:    #fff;
  animation:     rebound .3s
}

.con-vs-dialog .vs-dialog.locked {
  transform: scale(1.02)
}

.con-vs-dialog .vs-dialog .vs-dialog-text {
  padding:    10px;
  font-size:  .875em;
  transition: all .23s ease .1s
}

.con-vs-dialog .vs-dialog header {
  width:           100%;
  display:         -ms-flexbox;
  display:         flex;
  -ms-flex-align:  center;
  align-items:     center;
  -ms-flex-pack:   justify;
  justify-content: space-between;
  background:      #f8f8f8;
  border-radius:   5px 5px;
  position:        relative
}

.con-vs-dialog .vs-dialog header .con-title-after {
  width:         100%;
  position:      relative;
  overflow:      hidden;
  border-radius: 5px 5px 0 0
}

.con-vs-dialog .vs-dialog header span.after {
  transition: all .23s ease .1s;
  position:   absolute;
  top:        50%;
  transform:  translateY(-50%);
  width:      3px;
  height:     100%;
  display:    block
}

.vuesax-app-is-rtl .con-vs-dialog .vs-dialog header span.after {
  right: 0
}

.vuesax-app-is-ltr .con-vs-dialog .vs-dialog header span.after {
  left: 0
}

.con-vs-dialog .vs-dialog header h3 {
  transition: all .23s ease .1s;
  padding:    8px;
  font-size:  1rem;
  margin:     0
}

.vuesax-app-is-rtl .con-vs-dialog .vs-dialog header h3 {
  padding-right: 12px
}

.vuesax-app-is-ltr .con-vs-dialog .vs-dialog header h3 {
  padding-left: 12px
}

.con-vs-dialog .vs-dialog header .vs-dialog-cancel {
  transition:    all .23s ease .1s;
  position:      relative;
  padding:       8px;
  cursor:        pointer;
  box-shadow:    0 5px 20px 0 rgba(0, 0, 0, .1);
  border-radius: 5px;
  background:    #fff;
  font-size:     1.25em
}

.vuesax-app-is-rtl .con-vs-dialog .vs-dialog header .vs-dialog-cancel {
  transform: translate(-8px, -8px)
}

.vuesax-app-is-ltr .con-vs-dialog .vs-dialog header .vs-dialog-cancel {
  transform: translate(8px, -8px)
}

.con-vs-dialog .vs-dialog header .vs-dialog-cancel:hover {
  box-shadow: 0 0 0 0 rgba(0, 0, 0, .1)
}

.vuesax-app-is-rtl .con-vs-dialog .vs-dialog header .vs-dialog-cancel:hover {
  transform: translate(-5px, -5px)
}

.vuesax-app-is-ltr .con-vs-dialog .vs-dialog header .vs-dialog-cancel:hover {
  transform: translate(5px, -5px)
}

.con-vs-dialog .vs-dialog footer {
  display:         -ms-flexbox;
  display:         flex;
  -ms-flex-align:  center;
  align-items:     center;
  -ms-flex-pack:   end;
  justify-content: flex-end;
  position:        relative
}

.vuesax-app-is-rtl .con-vs-dialog .vs-dialog footer button {
  margin-right: 0
}

.vuesax-app-is-ltr .con-vs-dialog .vs-dialog footer button {
  margin-left: 0
}

.con-vs-dialog .vs-dialog footer:before {
  content:    "";
  top:        0;
  left:       0;
  position:   absolute;
  width:      90%;
  height:     1px;
  background: rgba(0, 0, 0, .05)
}

.vuesax-app-is-rtl .con-vs-dialog .vs-dialog footer:before {
  margin-right: 5%
}

.vuesax-app-is-ltr .con-vs-dialog .vs-dialog footer:before {
  margin-left: 5%
}

.vs-dialog-primary .vs-dialog .vs-dialog-header {
  color: rgba(var(--vs-primary), 1)
}

.vs-dialog-primary .vs-dialog .after {
  background: rgba(var(--vs-primary), 1)
}

.vs-dialog-secondary .vs-dialog .vs-dialog-header {
  color: rgba(var(--vs-secondary), 1)
}

.vs-dialog-secondary .vs-dialog .after {
  background: rgba(var(--vs-secondary), 1)
}

.vs-dialog-danger .vs-dialog .vs-dialog-header {
  color: rgba(var(--vs-danger), 1)
}

.vs-dialog-danger .vs-dialog .after {
  background: rgba(var(--vs-danger), 1)
}

.vs-dialog-success .vs-dialog .vs-dialog-header {
  color: rgba(var(--vs-success), 1)
}

.vs-dialog-success .vs-dialog .after {
  background: rgba(var(--vs-success), 1)
}

.vs-dialog-warning .vs-dialog .vs-dialog-header {
  color: rgba(var(--vs-warning), 1)
}

.vs-dialog-warning .vs-dialog .after {
  background: rgba(var(--vs-warning), 1)
}

.vs-dialog-dark .vs-dialog .vs-dialog-header {
  color: rgba(var(--vs-dark), 1)
}

.vs-dialog-dark .vs-dialog .after {
  background: rgba(var(--vs-dark), 1)
}

.vs-dialog-light .vs-dialog .vs-dialog-header {
  color: rgba(var(--vs-light), 1)
}

.vs-dialog-light .vs-dialog .after {
  background: rgba(var(--vs-light), 1)
}

* {
  --vs-primary: 115, 103, 240;
  --vs-success: 40, 199, 111;
  --vs-danger:  234, 84, 85;
  --vs-warning: 255, 159, 67;
  --vs-dark:    30, 30, 30;
  --vh:         9.69px;
}

.whitespace-no-wrap {
  white-space: nowrap !important;
}

.con-vs-checkbox, .con-vs-radio {
  justify-content: flex-start !important;
}

.con-vs-checkbox {
  position:        relative;
  display:         block;
  display:         -ms-flexbox;
  display:         flex;
  -ms-flex-align:  center;
  align-items:     center;
  -ms-flex-pack:   center;
  justify-content: center;
  margin-left:     5px;
  margin-right:    5px
}

.con-vs-checkbox.vs-checkbox-small .vs-checkbox {
  width:  15px;
  height: 15px
}

.con-vs-checkbox.vs-checkbox-small .vs-checkbox .vs-icon {
  font-size: .61rem
}

.con-vs-checkbox.vs-checkbox-large .vs-checkbox {
  width:  24px;
  height: 24px
}

.vs-checkbox--input {
  position:   absolute;
  width:      100%;
  height:     100%;
  opacity:    0;
  z-index:    200;
  cursor:     pointer;
  background: #55d775
}

.vs-checkbox--input:disabled {
  cursor:         default;
  pointer-events: none
}

.vs-checkbox--input:disabled + .vs-checkbox {
  opacity:        .5;
  cursor:         default;
  pointer-events: none
}

.vs-checkbox--input:disabled + .vs-checkbox .vs-checkbox--check {
  cursor:         default;
  pointer-events: none
}

.vs-checkbox--input:active:checked + .vs-checkbox .vs-checkbox--check {
  transform: translate(3px)
}

.vs-checkbox--input:active:checked + .vs-checkbox .vs-icon {
  transform: translate(6px)
}

.vs-checkbox--input:checked + .vs-checkbox {
  transform: rotate(0deg)
}

.vs-checkbox--input:checked + .vs-checkbox .vs-checkbox--check {
  transform: translate(0)
}

.vs-checkbox--input:checked + .vs-checkbox .vs-icon {
  opacity:   1;
  transform: translate(0);
  color:     #fff;
  display:   -ms-flexbox;
  display:   flex
}

.vs-checkbox, .vs-checkbox--input:checked + .vs-checkbox .vs-icon {
  -ms-flex-align:  center;
  align-items:     center;
  -ms-flex-pack:   center;
  justify-content: center
}

.vs-checkbox {
  transition:    all .2s ease;
  cursor:        pointer;
  position:      relative;
  display:       block;
  width:         20px;
  height:        20px;
  border-radius: 2px;
  display:       -ms-flexbox;
  display:       flex;
  transform:     rotate(-90deg);
  overflow:      hidden;
  box-sizing:    border-box
}

.vuesax-app-is-rtl .vs-checkbox {
  margin-left: 5px
}

.vuesax-app-is-ltr .vs-checkbox {
  margin-right: 5px
}

.vs-checkbox--check {
  width:            100%;
  height:           100%;
  position:         absolute;
  left:             0;
  transform:        translate(100%);
  transform-origin: right;
  transition:       all .2s ease;
  z-index:          10
}

.vs-checkbox--check {
  display:         flex;
  align-items:     center;
  justify-content: center;
}

.vs-checkbox--icon {
  -webkit-backface-visibility: visible;
  backface-visibility:         visible;
  transition:                  all .2s ease-out;
  z-index:                     100;
  font-size:                   1.125em;
  opacity:                     0;
  transform:                   translate(30px);
  transform-origin:            center
}

.vs-checkbox-primary .vs-checkbox {
  border: 2px solid #b4b4b4
}

.vs-checkbox-primary input:checked + .vs-checkbox {
  border:     2px solid rgba(var(--vs-primary), 1) !important;
  background: rgba(var(--vs-primary), 1)
}

.vs-checkbox-secondary .vs-checkbox {
  border: 2px solid #b4b4b4
}

.vs-checkbox-secondary input:checked + .vs-checkbox {
  border:     2px solid rgba(var(--vs-secondary), 1) !important;
  background: rgba(var(--vs-secondary), 1)
}

.vs-checkbox-danger .vs-checkbox {
  border: 2px solid #b4b4b4
}

.vs-checkbox-danger input:checked + .vs-checkbox {
  border:     2px solid rgba(var(--vs-danger), 1) !important;
  background: rgba(var(--vs-danger), 1)
}

.vs-checkbox-success .vs-checkbox {
  border: 2px solid #b4b4b4
}

.vs-checkbox-success input:checked + .vs-checkbox {
  border:     2px solid rgba(var(--vs-success), 1) !important;
  background: rgba(var(--vs-success), 1)
}

.vs-checkbox-warning .vs-checkbox {
  border: 2px solid #b4b4b4
}

.vs-checkbox-warning input:checked + .vs-checkbox {
  border:     2px solid rgba(var(--vs-warning), 1) !important;
  background: rgba(var(--vs-warning), 1)
}

.vs-checkbox-dark .vs-checkbox {
  border: 2px solid #b4b4b4
}

.vs-checkbox-dark input:checked + .vs-checkbox {
  border:     2px solid rgba(var(--vs-dark), 1) !important;
  background: rgba(var(--vs-dark), 1)
}

.vs-checkbox-light .vs-checkbox {
  border: 2px solid #b4b4b4
}

.vs-checkbox-light input:checked + .vs-checkbox {
  border:     2px solid rgba(var(--vs-light), 1) !important;
  background: rgba(var(--vs-light), 1)
}

.con-vs-dialog {
  z-index: 52005;
}

.con-vs-dialog.email-compose .vs-dialog {
  max-width: 530px;
}

.con-vs-dialog .vs-dialog header span.after {
  width: 0;
}

.con-vs-dialog .vs-dialog header .dialog-title {
  color: inherit;
}

.con-vs-dialog .vs-dialog header .dialog-title {
  padding: 0.7rem;
}

.con-vs-dialog .vs-dialog .vs-dialog-text {
  padding: 0.88rem;
}

.con-vs-dialog.email-compose .vs-dialog .vs-dialog-text {
  padding: 0;
}

.scroll-area {
  position: relative;
  width:    100%;
  height:   100%;
}

.scroll-area {
  margin: auto;
}

.con-vs-dialog.email-compose .vs-dialog .vs-dialog-text .scroll-area {
  max-height: 75vh;
}

.w-full {
  width: 100% !important;
}

.vs-con-input-label {
  position:   relative;
  transition: all .3s ease;
  width:      200px;
}

.mb-6 {
  margin-bottom: 1.32rem !important;
}

.vs-con-input-label.is-label-placeholder {
  margin-top: 17px;
}

.vs-con-input-label .vs-con-input {
  display:            -ms-flexbox;
  display:            flex;
  -ms-flex-align:     start;
  align-items:        flex-start;
  -ms-flex-direction: column;
  flex-direction:     column;
  position:           relative;
  -ms-flex-pack:      center;
  justify-content:    center;
}

.vs-input--input {
  color:         inherit;
  position:      relative;
  padding:       .4rem;
  border-radius: 5px;
  border:        1px solid rgba(0, 0, 0, .2);
  box-sizing:    border-box;
  box-shadow:    0 0 0 0 rgba(0, 0, 0, .15);
  transition:    all .3s ease;
  width:         100%;
}

.vs-input--input.normal {
  padding: .35rem;
}

.vs-con-input .vs-inputx {
  font-size: 0.88rem;
}

.vs-input--input.normal {
  font-size: 0.88rem !important;
}

.vs-con-input .vs-inputx {
  padding: 0.61rem;
  border:  1px solid rgba(0, 0, 0, 0.2);
}

.vs-input--input.normal {
  padding: 0.61rem !important;
}

.vs-input--placeholder {
  transition:          all .2s ease;
  position:            absolute;
  border-radius:       5px;
  padding:             .4rem;
  width:               100%;
  box-sizing:          border-box;
  overflow:            hidden;
  font-size:           .85rem;
  color:               rgba(0, 0, 0, .4);
  white-space:         nowrap;
  cursor:              text;
  -webkit-user-select: none;
  -ms-user-select:     none;
  user-select:         none;
  top:                 -1px;
  pointer-events:      none;
}

.vs-input--placeholder {
  top: 0;
}

.vuesax-app-is-ltr .vs-input--placeholder {
  left: 0;
}

.vuesax-app-is-ltr .vs-input--placeholder {
  padding-left: .48rem;
}

.vs-input--placeholder.normal {
  padding: 0.61rem !important;
}

.vs-input--input:focus {
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, .15);
}

.vs-input-danger .vs-input--input:focus {
  border: 1px solid rgba(234, 84, 85, 1) !important;
}

.vuesax-app-is-ltr .vs-input--input:focus + .vs-placeholder-label {
  transform: translate(-3px, -90%) !important;
}

.vuesax-app-is-ltr .vs-input--input.hasValue + .vs-placeholder-label, .vuesax-app-is-ltr .vs-input--input:focus + .vs-placeholder-label {
  padding-left: .5rem !important;
}

.vuesax-app-is-ltr .vs-input--input:focus + .vs-input--placeholder {
  transform: translate(5px);
}

input--input:focus ~ .icon-inputx, .vs-input-danger .vs-input--input:focus ~ .vs-placeholder-label {
  color: rgba(234, 84, 85, 1);
}

.vs-input--input {
  outline-width: 0;
}

.vs-input--input.hasValue + .vs-placeholder-label, .vs-input--input:focus + .vs-placeholder-label {
  font-size: .6rem;
}

.vs-input-primary .vs-input--input:focus {
  border: 1px solid rgba(115, 103, 240, 1) !important;
}

.vs-input-warning .vs-input--input:focus {
  border: 1px solid rgba(255, 159, 67, 1) !important;
}

.vs-input-success .vs-input--input:focus {
  border: 1px solid rgba(40, 199, 111, 1) !important;
}

.vs-input-dark .vs-input--input:focus {
  border: 1px solid rgba(30, 30, 30, 1) !important;
}

.vs-dialog .p-4 {
  padding: 0.88rem !important;
}

.vs-input-primary.isFocus .vs-input--label, .vs-input-primary .vs-input--input:focus ~ .icon-inputx, .vs-input-primary .vs-input--input:focus ~ .vs-placeholder-label {
  color: rgba(115, 103, 240, 1);
}

.vs-input-warning.isFocus .vs-input--label, .vs-input-warning .vs-input--input:focus ~ .icon-inputx, .vs-input-warning .vs-input--input:focus ~ .vs-placeholder-label {
  color: rgba(255, 159, 67, 1);
}

.vs-input-success.isFocus .vs-input--label, .vs-input-success .vs-input--input:focus ~ .icon-inputx, .vs-input-success .vs-input--input:focus ~ .vs-placeholder-label {
  color: rgba(40, 199, 111, 1);
}

.vs-input-dark.isFocus .vs-input--label, .vs-input-dark .vs-input--input:focus ~ .icon-inputx, .vs-input-dark .vs-input--input:focus ~ .vs-placeholder-label {
  color: rgba(30, 30, 30, 1);
}

.con-vs-dialog.email-compose .quill-editor {
  margin-bottom: 1.32rem;
}

.con-vs-dialog.email-compose .ql-editor {
  height: 150px;
}

.ql-container {
  height: 100%;
}

.vs-input--icon-validate {
  position:       absolute;
  top:            0;
  font-size:      0.96rem;
  height:         100%;
  display:        -ms-flexbox;
  display:        flex;
  -ms-flex-align: center;
  align-items:    center;
  padding:        0 4px;
  border-radius:  0 5px 5px 0;
  transition:     all .2s ease;
}

.vuesax-app-is-ltr .vs-input--icon-validate {
  right: 0;
}

.input-icon-validate-danger .input-icon-validate {
  background: rgba(234, 84, 85, .2);
  color:      rgba(234, 84, 85, 1);
}

.vuesax-app-is-ltr .vs-input--input.hasValue + .vs-placeholder-label, .vuesax-app-is-ltr .vs-input--input:focus + .vs-placeholder-label {
  transform: translate(-3px, -90%) !important;
}

.con-upload {
  width:    100%;
  position: relative;
}

.con-img-upload {
  width:         100%;
  background:    #fff;
  margin-top:    5px;
  padding-right: 5px;
  box-sizing:    border-box;
  column-gap:    5px;
}

.con-img-upload, .con-img-upload .img-upload {
  position:      relative;
  border-radius: 10px;
  overflow:      hidden;
}

.con-img-upload {
  overflow: hidden;
}

.con-img-upload {
  padding: 0.52rem;
}

.con-input-upload {
  background:         #f5f5f5;
  width:              200px;
  height:             200px;
  box-sizing:         border-box;
  border-radius:      8px;
  position:           relative;
  transition:         all .25s ease;
  border:             1px dashed rgba(0, 0, 0, .1);
  display:            -ms-flexbox;
  display:            flex;
  -ms-flex-align:     center;
  align-items:        center;
  -ms-flex-pack:      center;
  justify-content:    center;
  -ms-flex-direction: column;
  flex-direction:     column;
  margin:             15px;
}

.vuesax-app-is-ltr .con-input-upload {
  float: left;
}

.con-vs-dialog.email-compose .con-img-upload .con-input-upload {
  height: 2.2rem;
  width:  100%;
}

.con-vs-dialog.email-compose .vs-dialog .vs-dialog-text .compose-mail-attachment .con-input-upload {
  margin: 0;
}

.con-input-upload input {
  position: absolute;
  width:    100%;
  height:   100%;
  opacity:  0;
  left:     0;
  top:      0;
  cursor:   pointer;
}

.con-input-upload .text-input {
  min-width:   200px;
  display:     block;
  text-align:  center;
  margin:      0 !important;
  padding:     0 !important;
  width:       100%;
  font-weight: 700;
}

.con-img-upload .img-upload {
  -webkit-backface-visibility: hidden;
  backface-visibility:         hidden;
  background:                  rgba(0, 80, 0, .5);
  background:                  #fff;
  box-shadow:                  0 5px 20px 0 rgba(0, 0, 0, .1);
  transition:                  all .3s ease;
  display:                     -ms-flexbox;
  display:                     flex;
  -ms-flex-align:              center;
  align-items:                 center;
  -ms-flex-pack:               center;
  justify-content:             center;
  -ms-flex-direction:          column;
  flex-direction:              column;
  width:                       200px;
  height:                      200px;
  margin:                      5px;
  cursor:                      pointer;
}

.vuesax-app-is-ltr .con-img-upload .img-upload {
  float: left;
}

.con-img-upload .img-upload {
  margin: 15px;
}

.con-vs-dialog.email-compose .con-img-upload .img-upload {
  margin: 0 0 0.44rem;
}

.con-vs-dialog.email-compose .con-img-upload .img-upload {
  margin-right: 1.32rem;
}

.con-img-upload .img-upload .btn-x-file {
  display:       block;
  position:      absolute;
  top:           5px;
  padding:       0;
  margin:        0;
  transform:     translate(20%, -20%);
  background:    transparent;
  z-index:       300;
  opacity:       0;
  border:        0;
  cursor:        pointer;
  transition:    all .2s ease;
  border-radius: 10px;
}

.vuesax-app-is-ltr .con-img-upload .img-upload .btn-x-file {
  right: 5px;
}

.con-img-upload .img-upload .btn-x-file i {
  transition:      all .2s ease;
  position:        relative;
  padding:         4px;
  font-size:       1.4rem;
  display:         -ms-flexbox;
  display:         flex;
  -ms-flex-align:  center;
  align-items:     center;
  -ms-flex-pack:   center;
  justify-content: center;
  border-radius:   5px;
  background:      rgba(0, 0, 0, .1);
  color:           #fff;
  text-shadow:     0 3px 10px rgba(0, 0, 0, .5);
}

.img-upload {
  h4, .h4 {
    font-size:   18.48px;
    font-family: inherit;
    font-weight: 500;
    line-height: 1.2;
    color:       #2c2c2c;
  }
}

.con-img-upload .img-upload .text-archive {
  display:         -ms-flexbox;
  display:         flex;
  -ms-flex-align:  center;
  align-items:     center;
  -ms-flex-pack:   center;
  justify-content: center;
  position:        relative;
  text-align:      center;
  padding:         5px;
}

.con-img-upload .img-upload .text-archive i {
  position:  absolute;
  font-size: 6.1rem;
  opacity:   .05;
}

.con-img-upload .img-upload .text-archive span {
  position: relative;
  padding:  5px;
}

.con-img-upload .img-upload:hover {
  transform:  scale(.99);
  box-shadow: 0 0 0 0 rgba(0, 0, 0, .1);
}

.con-img-upload .img-upload:hover .btn-x-file {
  opacity:   1;
  transform: translate(0);
}

.con-img-upload .img-upload:hover .btn-x-file {
  opacity:   1;
  transform: translate(0);
}

.con-img-upload .img-upload .btn-x-file:hover i {
  border-radius: 50%;
  background:    rgba(234, 84, 85, 1);
}

.con-img-upload .img-upload.removeItem {
  transition: all .3s ease, height .2s ease .2s;
  opacity:    0 !important;
  width:      0 !important;
  visibility: hidden;
  margin:     0 !important;
  height:     0 !important;
}

.con-vs-dialog .vs-dialog footer {
  display:         -ms-flexbox;
  display:         flex;
  -ms-flex-align:  center;
  align-items:     center;
  -ms-flex-pack:   end;
  justify-content: flex-end;
  position:        relative;
}

.con-vs-dialog .vs-dialog footer {
  padding: 0.88rem;
}

.con-vs-dialog .vs-dialog footer:before {
  content:    "";
  top:        0;
  left:       0;
  position:   absolute;
  width:      90%;
  height:     1px;
  background: rgba(0, 0, 0, .05);
}

.vuesax-app-is-ltr .con-vs-dialog .vs-dialog footer:before {
  margin-left: 5%;
}

.vs-button {
  transition:    all .2s ease;
  padding:       10px;
  border:        0;
  border-radius: 6px;
  cursor:        pointer;
  position:      relative;
  overflow:      hidden;
  color:         #fff;
  box-sizing:    border-box;
  background:    transparent;
}

.vs-button {
  font-family: "Montserrat", Helvetica, Arial, sans-serif;
  font-size:   0.88rem;
}

.vs-button:disabled {
  opacity:        .5;
  cursor:         default;
  pointer-events: none;
}

.vs-button-primary.vs-button-filled {
  background: rgba(115, 103, 240, 1) !important;
}

.vuesax-app-is-ltr .con-vs-dialog .vs-dialog footer button {
  margin-left: 0;
}

.vs-button:not(.vs-radius):not(.includeIconOnly):not(.small):not(.large) {
  padding: 0.66rem 1.76rem;
}

.vs-button--background {
  border-radius:  50%;
  width:          10px;
  position:       absolute;
  height:         10px;
  z-index:        0;
  transform:      translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  box-shadow:     inset 0 0 60px 0 hsla(0, 0%, 100%, .5);
}

.vs-button-filled:hover {
  box-shadow: 0 9px 28px -9px;
}

.vs-button-primary.vs-button-filled:hover {
  box-shadow: 0 8px 25px -8px rgba(115, 103, 240, 1);
}

.vs-button--text {
  position:   relative;
  color:      inherit;
  display:    inline-block;
  transition: all .25s ease;
}

.vs-button-primary.vs-button-border, .vs-button-primary.vs-button-flat {
  border:     1px solid rgba(115, 103, 240, 1);
  background: transparent !important;
  color:      rgba(115, 103, 240, 1);
}

.vs-button-primary.vs-button-flat {
  border: none !important;
}

.con-vs-dialog .vs-dialog footer .vs-button:last-of-type {
  border-color: rgba(0, 0, 0, 0.2) !important;
}

.con-vs-dialog .vs-dialog footer .vs-button:last-of-type {
  margin-left: 0.5rem !important;
}

.vs-button-primary.vs-button-border .vs-button-backgroundx, .vs-button-primary.vs-button-flat .vs-button-backgroundx {
  background: rgba(115, 103, 240, 1);
  box-shadow: inset 0 0 60px 0 rgba(115, 103, 240, 1);
}

.vs-button-primary.vs-button-border:hover, .vs-button-primary.vs-button-flat:hover {
  background: rgba(115, 103, 240, .08) !important;
}

.input-icon-validate-success .input-icon-validate {
  background: rgba(40, 199, 111, .2);
  color:      rgba(40, 199, 111, 1);
}

.vs__selected-options input::placeholder {
  color:     rgba(0, 0, 0, 0.4);
  font-size: 0.85rem;
}

.vs__selected-options input {
  font-size: 0.88rem;
  padding:   0.4rem;
}

.vs__selected-options input:focus {
  font-size: 0.88rem;
  padding:   0.4rem;
}

</style>
